import React from "react";
export default (({
  styles = {},
  ...props
}) => <svg data-name="Layer 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 22 16" {...props}><path d="M21.715 7.3l-6.841-7a1 1 0 10-1.43 1.4l5.18 5.3H1a1 1 0 000 2h17.624l-5.18 5.3a1 1 0 101.43 1.4l6.841-7a1 1 0 000-1.4z" fill="#4343f0" /></svg>);